'use strict';

var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

let ErrorBoundary = class ErrorBoundary extends React.Component {
    static getDerivedStateFromError(_) {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return /*#__PURE__*/ jsxRuntime.jsx("h1", {
                children: "Sorry.. there was an error"
            });
        }
        return this.props.children;
    }
    constructor(...args){
        super(...args);
        this.state = {
            hasError: false
        };
    }
};

module.exports = ErrorBoundary;
